module.exports = __webpack_public_path__ + "media/images/landing/logo-sama@2x-897495214f986bf4f31d8c0051b3366a.png";